import React from "react";

interface Props
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLTableSectionElement>, HTMLTableSectionElement> {}

const TFoot: React.FC<Props> = ({ className = "table__foot", children, ...props }) => {
    return (
        <tfoot className={className} {...props}>
            {children}
        </tfoot>
    );
};

export default TFoot;
